module.exports = __webpack_public_path__ + "img/cateicon1.6f001036.svg";